import HttpService from "./htttp.service";

class ParametersService {
  getParameters = async (page, pageSize, sortColumn, sortColumnValue, searchValue) => {
    let fetchUrl = "parameters";
    if (page && pageSize && sortColumn && sortColumnValue) {
      fetchUrl = `parameters?page=${page}&per_page=${pageSize}&sort_column=${
        sortColumn
      }&sort_column_value=${sortColumnValue}&search_value=${encodeURIComponent(searchValue)}`;
    }
    return await HttpService.get(fetchUrl);
  };

  addParameter = async (newParameter) => {
    const fetchUrl = "parameters";
    return await HttpService.post(fetchUrl, newParameter);
  };

  updateParameter = async (id, data) => {
    const fetchUrl = `parameters/${id}`;
    return await HttpService.put(fetchUrl, data);
  };

  updateParameterStatus = async (id, data) => {
    const fetchUrl = `parameters/${id}`;
    return await HttpService.patch(fetchUrl, data);
  };

  showParameter = async (id) => {
    const fetchUrl = `parameters/${id}`;
    return await HttpService.get(fetchUrl);
  };

  deleteParameter = async (id) => {
    const fetchUrl = `parameters/${id}`;
    return await HttpService.delete(fetchUrl);
  };
}

export default new ParametersService();
